module.exports = __webpack_public_path__ + "img/LUB00082.6c13f111.png";